var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 24C5.84375 24 0.5 18.6562 0.5 12C0.5 5.39062 5.84375 0 12.5 0C19.1094 0 24.5 5.39062 24.5 12C24.5 18.6562 19.1094 24 12.5 24ZM11.375 12C11.375 12.375 11.5625 12.75 11.8438 12.9375L16.3438 15.9375C16.8594 16.3125 17.5625 16.1719 17.8906 15.6562C18.2656 15.1406 18.125 14.4375 17.6094 14.0625L13.625 11.4375V5.625C13.625 5.01562 13.1094 4.5 12.4531 4.5C11.8438 4.5 11.3281 5.01562 11.3281 5.625L11.375 12Z",
    fill: "#1D4F8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.96021a871325ae16dbbf9e9d9eb14685.svg";
export { ForwardRef as ReactComponent };